<template>
  <div id="site-search" class="site-search">
    <div class="content-max-width">
    
      <button class="circle" @click="closeSearch()">
        <img src="/images/icons/close.svg" alt="Habit Health exit">
      </button>

      <div class="text-search">
        <label>Start typing to search...</label>
        <input type="text" ref="search"
          v-model="payload.keyword" v-debounce:750ms="liveSearch"
        >
      </div>

      <div class="filters">
        <label>Filter Results</label>

        <div class="filter-options">
          <a
            class="button navy-border" :class="{ 'active' : payload.module_type.length === 0 }"
            @click="payload.module_type = []; liveSearch()"
          >
            Show all
          </a>

          <a
            class="button navy-border" :class="{ 'active' : payload.module_type.includes(type.id) && payload.module_type !== []  }"
            v-for="type of module_type" 
            @click="filter(type.id)"
          >
            {{ type.title }}
          </a>
        </div>
      </div>

      <div class="all-results flex flex-between">
        
        <div class="block results">
          <label v-if="results.length">Search Results</label>
          <label v-else>All Services</label>

          <div class="wrap" v-if="results.length">
            <a :href="link.url" v-for="link of results" >
              {{ link.title }}
            </a>
          </div>

          <div class="wrap" v-else>
            <a :href="link.url" v-for="link of all_services" >
              {{ link.title }}
            </a>
          </div>

        </div>

        <div class="block popular">
          <label>Popular Searches</label>
          
          <div class="wrap">
            <a :href="link.url" v-for="link of popular_searches" >
              {{ link.title }}
            </a>
          </div>
        </div>

        <div class="block recent">
          <label>Recently Viewed</label>
          
          <div class="wrap">
            <a :href="link.url" v-for="link of recent" >
              {{ link.title }}
            </a>
          </div>
        </div>

      </div>
    
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groups: Array,
    module_type: Array,
    search_url: String,
    all_services: Array,
    popular_searches: Array
  },
  data () {
    return {
      payload: {
        module_type: [],
        // group_items: [],
        keyword: ''
      },
      results: [],
      recent: [
        { title: 'Pain Management', url: '' },
        { title: 'Concussion Service', url: '' },
        { title: 'Massage Therapy', url: '' }
      ]
    };
  },
  computed: {
    allModules () {
      let ids = []
      this.module_type.filter(obj => ids.push(obj.id))
      return ids
    }
  },
  mounted () {
    this.$refs.search.focus()
  },
  methods: {
    filter (id) {
      if (this.payload.module_type !== this.allModules) {
        if (this.payload.module_type.includes(id)) {
          // remove existing id
          const index = this.payload.module_type.indexOf(id)
          this.payload.module_type.splice(index, 1)
        } else {
          // add id
          this.payload.module_type.push(id)
        }

        this.liveSearch()
      } else {
        this.payload.module_type = []
        this.payload.module_type.push(id)
        this.liveSearch()
      }
    },

    closeSearch () {
      this.$emit('close')
    },

    liveSearch () {
      window.axios.post(this.search_url, this.payload)
        .then((response) => {
          this.$store.commit('setLoading', false)

          this.results = response.data.data
        })
        .catch((error) => {
          console.log('prodd error', error)
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            content: '<p>Sorry, the search-results could not be loaded.</p>',
            open: true
          })
        })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../sass/core/variables.scss";

.site-search {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999999;
    
    width: 100%;
    height: 100%;
    padding: 100px 0;

    background: white;
    overflow: auto;

    button.circle {
      position: absolute;
      top: 0px;
      right: 15px;

      @media (min-width: $medium) {
        top: -41px;
      }
    }

    .text-search {
      padding: 0 0 20px;
      
      border-bottom: 1px solid #d7e0e7;

      label {
        margin: 0;

        font-size: 18px;
        font-weight: 500;
        line-height: 26px;
        color: #657781;
      }

      input {
        width: 100%;
        height: 78px;
        padding: 20px 0;

        font-family: $font-family-2;
        font-size: 30px;
        font-weight: 600;
        line-height: 38px;
        letter-spacing: -0.45px;
        color: $grey-4;
        
        border: none;
        background: white;

        @media (min-width: $medium) {
          height: 108px;

          font-size: 60px;
          line-height: 68px;
        }
      }

      input:focus {
        box-shadow: none;
      }
    }

    .filters {
      margin: 0 0 30px;
      padding: 30px 0;

      border-bottom: 1px solid #d7e0e7;

      label {
        display: inline-block;
        width: 100%;
        margin: 0;
        
        font-size: 14px;
        font-weight: 600;
        letter-spacing: -0.17px;
        line-height: 42px;
        color: $grey-4;

        @media (min-width: $medium) {
          width: 98px;
        }
      }

      .filter-options {
        display: inline-block;
        width: calc(100% - 103px);

        font-size: 0;

        .button {
          display: inline-block;
          min-width: 93px;
          padding: 0 10px;

          border-color: #d7e0e7;
          border-radius: 0;

          @media (min-width: $medium) {
            min-width: 113px;
            padding: 0 17px;
          }
        }

        .button.active { border-color: $color-1; }

        .button:first-of-type { border-radius: 3px 0 0 3px; }
        .button:last-of-type { border-radius: 0 3px 3px 0; }
      }
    }

    .all-results {
      .block {
        position: relative;

        width: 100%;
        margin-bottom: 30px;

        @media (min-width: $medium) {
          width: calc(33.33% - 25px);
          margin-bottom: 0;
        }

        label {
          width: 100%;
          margin-bottom: 20px;

          font-size: 14px;
          font-weight: 500;
          line-height: 18px;
          color: $grey-3;
        }

        .wrap {
          width: 100%;
          max-height: 378px;

          overflow: auto;

          a {
            display: inline-block;
            width: 100%;
            margin: 0 0 5px;
            padding: 19px 20px;

            font-size: 14px;
            font-weight: 600;
            letter-spacing: -0.2px;
            line-height: 18px;
            color: $grey-4;

            border: 1px solid #d7e0e7;
            border-left: 3px solid $color-2;
          }
        }
      }

      .block.results {
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          z-index: 2;

          width: 100%;
          height: 31px;

          background: linear-gradient(180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
        }

        .wrap a {
          background: #f5f6f8;
          border-color: #f5f6f8;
        }
      }
    }
}

</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HeaderSearch.vue